// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"RelationEditor__container___t8yox","relationCheckBoxLabel":"RelationEditor__relationCheckBoxLabel___3j7D6","hiddenRelationCheckbox":"RelationEditor__hiddenRelationCheckbox___3KZ12"};
    if(module.hot) {
      // 1751719784118
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  